<template>
    <div class="footer">
        <!-- Upper section with left and right content -->
        <div class="footer-upper">
            <div class="footer-upper-left">
                <p>{{ $t('footer.phone') }}: </p>
                <p>
                    <a href="tel:+421949524830">+421 949 524 830</a>
                </p>
            </div>
            <div class="footer-upper-right">
                <p>{{ $t('footer.mail') }}: </p>
                <p>
                    <a href="mailto:info@apartmanydanka.sk">info@apartmanydanka.sk</a>
                </p>
            </div>
        </div>
        
        <!-- Bottom section -->
        <div class="footer-bottom">
            <p>{{ $t('footer.copyright') }}</p>
        </div>
    </div>
</template>

<style scoped>
.footer {
    position: relative;
    background-color: var(--primary-color);
    padding: var(--spacing-md);
    width: 100%;
    color: white;
    font-size: 1rem;
    opacity: 0.75;
}

/* Upper section containing left and right parts */
.footer-upper {
    display: flex;
    justify-content: space-around;
    align-items: center;
    text-align: center;
    margin: 0 auto;
    width: 100%;
    max-width: 800px;
    min-height: 60px;
}

/* Upper left section */
.footer-upper-left {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: var(--spacing-sm);
    text-align: center;
}

/* Upper right section */
.footer-upper-right {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: var(--spacing-sm);
    text-align: center;
}

/* Ensure email doesn't wrap */
.footer-upper-left p,
.footer-upper-right p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
    display: inline-flex;
    align-items: center;
}

/* Bottom section */
.footer-bottom {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    padding-top: var(--spacing-md);
    margin-top: var(--spacing-md);
}

/* Link styling */
.footer a {
    color: white;
    text-decoration: none;
    transition: opacity 0.3s ease;
}

.footer a:hover {
    opacity: 0.8;
}

/* Responsive design */
@media (max-width: 768px) {
    .footer-upper {
        flex-direction: column;
        gap: var(--spacing-md);
        padding: var(--spacing-sm);
    }
    
    .footer-upper-left,
    .footer-upper-right {
        width: 100%;
        justify-content: center;
    }
    
    .footer-upper-left p,
    .footer-upper-right p {
        font-size: 0.9rem;
    }
}

@media (max-width: 480px) {
    .footer-upper-left,
    .footer-upper-right {
        flex-direction: column;
        gap: var(--spacing-xs);
    }
    
    .footer-upper-left p,
    .footer-upper-right p {
        font-size: 0.85rem;
    }
}
</style>